import { BalanceSheetReportType } from "pages/Finance/Report/types"
import { convertNumber } from "utils"

type ItemTotalProps = {
  item: BalanceSheetReportType
  isPNL?: boolean
}

export const ItemTotal = ({ item, isPNL }: ItemTotalProps) => {
  const isNormalFontWeight = [3].includes(item.header_level)
  // const shouldAbs = /^05-12/.test(String(item.coacode))
  const rawSummary = item?.balance?.reduce((acc, curr) => acc + (curr ?? 0), 0) ?? 0
  const summary = rawSummary
  const length = item?.balance?.length || 1
  const rawAverage = rawSummary / length
  const average = rawAverage
  

  return (
    <tr key={item.coa_id + "total"}>
      <td>
        <span
          style={{ marginLeft: (item.coa_level - 1) * 24 }}
          className={isNormalFontWeight ? "font-normal" : "font-bold"}>
          {`TOTAL ${item.coa_name}`}
        </span>
      </td>

      {item.balance?.map((balance, index) => {
        const displayBalance = balance ?? 0

        return (
          <td
            key={balance + index}
            className={`text-right ${isNormalFontWeight ? "font-normal" : "font-bold"}`}>
            {convertNumber(displayBalance).intoCurrency}
          </td>
        )
      })}

      {isPNL && (
        <td
          key={summary}
          className={`text-right ${isNormalFontWeight ? "font-normal" : "font-bold"}`}> 
          {convertNumber(summary).intoCurrency}
        </td>
      )}

      {isPNL && (
        <td
          key={average}
          className={`text-right ${isNormalFontWeight ? "font-normal" : "font-bold"}`}>
          {convertNumber(average).intoCurrency}
        </td>
      )}
    </tr>
  )
}
